import React from 'react';
import { connect } from 'react-redux';
import InputWhite from 'components/InputWhite';
import { queryChange, search } from 'browse-media/redux/browseMediaActions';
import styles from 'browse-media/components/BrowseMediaSearchInput.css';

const BrowseMediaSearchInput = ({ onKeyPress, onQueryChange, query }) =>
  <div className={styles.wrapper}>
    <InputWhite
      className={styles.input}
      icon="search"
      type="text"
      label="search..."
      name="search"
      value={query}
      onChange={onQueryChange}
      onKeyPress={onKeyPress}
    />
  </div>;

const mapStateToProps = state => ({
  query: state.browseMedia.query,
});

const mapDispatchToProps = dispatch => ({
  onKeyPress: event => {
    if (event.key === 'Enter') {
      dispatch(search());
    }
  },
  onQueryChange: query => dispatch(queryChange(query)),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  BrowseMediaSearchInput,
);
